export default "/assets/images/wall-of-love-hero-loop.5e21da1dc5fd22fb.mp4";